export default __webpack_public_path__ + "static/aicase3-c5e4bd51e6bdffb7205bcfc191d7da93.png";